import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=3421b2fe&scoped=true"
import script from "./RecoverPassword.js?vue&type=script&lang=js&external"
export * from "./RecoverPassword.js?vue&type=script&lang=js&external"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=3421b2fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3421b2fe",
  null
  
)

export default component.exports